import {HttpClient} from "../../service/httpClient/HttpClient";

export class FeaturesService {
    constructor() {
        this.httpClinet = new HttpClient()
    }

    getFeaturesLiat(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClinet.get(
                `fund-features`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewFeature(title, description,) {
        return new Promise((resolve, reject) => {
            this.httpClinet.post(
                `fund-features`,
                {
                    title,
                    description
                }
            ).then(resolve).catch(reject)
        })
    }

    getFeatureDetail(featureId) {
        return new Promise((resolve, reject) => {
            this.httpClinet.get(
                `fund-features/${featureId}`
            ).then(resolve).catch(reject)
        })
    }

    deleteFeature(featureId) {
        return new Promise((resolve, reject) => {
            this.httpClinet.delete(
                `fund-features/${featureId}`
            ).then(resolve).catch(reject)
        })
    }

    updateFeature(featureId, title, description) {
        return new Promise((resolve, reject) => {
            this.httpClinet.put(
                `fund-features/${featureId}`,
                {
                    title,
                    description
                }
            ).then(resolve).catch(reject)
        })
    }
}